/**
 * Phone Trigger
 * 点击一次显示全部电话，再次点击打电话
 * 
 * @Author: Focci
 * @Date: 2024-02-19 13:39:22
 * @Last Modified by: Focci
 * @Last Modified time: 2024-02-19 13:39:22
 */

'use client'

import PropTypes from 'prop-types'
import SVGPhone from '@img/phone.svg'
import { useState, useCallback, useRef, useEffect } from 'react'

export default function PhoneTrigger({
  phoneNumber,
  phoneLabel,
  className = [
    'inline-flex justify-center items-center gap-1 border border-helper cursor-pointer',
    'font-medium rounded-[.2rem] h-8 px-4 hover:bg-cf8'
  ].join(' '),
  onChange = () => {},
  ...props
}) {
  const refLink = useRef()
  const [showPhone, setShowPhone] = useState(false)

  const handleClick = useCallback(() => {
    setShowPhone(true)
    onChange(true)
  }, [onChange])

  const Tag = showPhone ? 'a' : 'div'
  const tagProps = showPhone ? { href: `tel:${phoneNumber}` } : null

  useEffect(() => {
    const el = refLink.current
    if(el) {
      el.addEventListener('click', handleClick, false)
      el.addEventListener('touchend', handleClick, false)
    }
    
    return () => {
      if(el) {
        el.removeEventListener('click', handleClick, false)
        el.removeEventListener('touchend', handleClick, false)
      }
    }
  }, [handleClick])

  if(!phoneNumber) {
    return null
  }

  return (
    <Tag
      data-noprogress
      ref={refLink}
      className={className}
      {...tagProps}
      {...props}
    >
      <SVGPhone />
      {
        showPhone 
          ? phoneNumber 
          : (phoneLabel || `${String(phoneNumber).slice(0, 6)} ...`)
      }
    </Tag>
  )
}

PhoneTrigger.propTypes = {
  phoneNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}
